import React from 'react';
import { Link } from 'react-router-dom';
import { User, PlayCircle, Home } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import CreditDisplay from './CreditDisplay';

interface NavigationProps {
  onOpenDrawer: () => void;
  /** Abre el modal del tutorial (solo se muestra para rol cliente). */
  onOpenTutorial?: () => void;
}

export const Navigation: React.FC<NavigationProps> = ({ onOpenDrawer, onOpenTutorial }) => {
  const profile = useSelector((state: RootState) => state.auth.profile);
  const user = useSelector((state: RootState) => state.auth.user);

  if (!user || !profile) {
    return null;
  }

  return (
    <div className="sticky top-0 z-30 border-b border-edge/70 bg-panel/95 px-3 py-2.5 backdrop-blur sm:px-6">
      <div className="mx-auto flex max-w-[1500px] items-center justify-between">
        <div className="flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold text-white tracking-tight hover:text-blue-400 transition-colors"
            title="Ir al inicio"
          >
            <Home className="w-5 h-5 shrink-0" />
            <span>Topógrafo</span>
          </Link>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          {profile && <CreditDisplay />}
          {onOpenTutorial && (
            <button
              type="button"
              onClick={onOpenTutorial}
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-300 hover:text-white hover:bg-gray-600/80 transition-colors border border-transparent hover:border-gray-500"
              title="Ver tutorial"
              aria-label="Abrir tutorial"
            >
              <PlayCircle className="w-5 h-5 shrink-0" strokeWidth={2} />
              <span className="hidden sm:inline text-sm font-medium">Tutorial</span>
            </button>
          )}
          <button
            type="button"
            onClick={onOpenDrawer}
            className="flex items-center gap-2 px-3 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
            aria-label="Abrir perfil"
          >
            <User className="w-5 h-5 shrink-0" />
            <span className="hidden sm:inline text-sm font-medium">Perfil</span>
          </button>
        </div>
      </div>
    </div>
  );
}; 